<template>
  <d2-container>
    <top-line :message="pageTitle" :iconclass="'fa fa-users'"></top-line>
    <el-row class="pagebody">
      <el-row class="filter-bar">
        <el-card shadow="never">
          <el-form :inline="true" :model="searchForm" ref="searchForm" label-width="200px" size="small">
            <el-row >
              <el-col :span="8">
                <el-form-item label="用户：" prop="username" class="search-item" :label-width="labelWidth">
                  <el-input v-model="searchForm.user" style="width:175px" />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-button type="primary" icon="el-icon-search" size="small" plain style="margin-left:8px;"
                           class="fr"
                           @click="handleSearch">
                  查询
                </el-button>
                <el-button type="info" icon="el-icon-refresh-left" size="small" plain style="margin-left:8px;"
                           class="fr"
                           @click="handleReset">
                  重置
                </el-button>

                <el-button type="primary" size="small" plain style="margin-left:8px;"
                           class="fr"
                           @click="userSynchronous">
                  用户同步
                </el-button>
              </el-col>
            </el-row>
          </el-form>
        </el-card>
      </el-row>

      <el-row class="main-table">
        <el-table :data="tableData" border stripe>
          <el-table-column type="index" align="center" width="75px" />
          <el-table-column prop="username" label="用户" width="160px" />
          <el-table-column prop="balance" label="余额（元）" align="right" width="120px"
              :formatter="formatCost"/>
          <el-table-column prop="updated_at" label="更新时间" width="200px" />
          <el-table-column prop="status" label="状态" width="160px">
            <template #default="{ row }">
              <el-tag :type="statusTagType(row.status)">
                {{ formatStatus(row.status) }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column header-align="center" align="center" show-overflow-tooltip width="150" label="操作">
          <template v-slot="scope">
            <!-- 使用 v-if 控制按钮的显示 -->
            <el-button 
              v-if="isAdmin === true" 
              type="text" 
              size="mini" 
              @click="updataedit(scope.row)">充值</el-button>

              <el-button 
              type="text" 
              size="mini" 
              @click="rechargeRecord(scope.row)">充值记录</el-button>
          </template>
        </el-table-column>
        </el-table>
      </el-row>
      <el-row type="flex" justify="left" style="margin-top: 10px; margin-bottom: 18px;">
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="pagination.page"
            :page-sizes="pagination.pageSizeList"
            :page-size="pagination.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="pagination.total">
        </el-pagination>
      </el-row>
    </el-row>

    <!-- 弹窗, 编辑 -->
    <edit-update ref="EditUpdate"  style="width:80%;margin-left:10%;" center />

  </d2-container>
</template>

<script>

import topLine from "@/components/save-common/topLine.vue";
import commonListMixin from "@/pages/mixin/mixin-common-list";
import EditUpdate from './user-recharge'
import { eventBus } from './eventBus'; // 导入 eventBus
import util from '@/libs/util.js'

export default {
  name: "allns",
  mixins: [
    commonListMixin
  ],
  components: {
    topLine,
    EditUpdate,
  },
  computed: {
    // 获取 isAdmin 状态
    isAdmin() {
      const adminStatus = util.cookies.get('isAdmin') === 'true';
      return adminStatus;
    }
  },
  mounted () {
    this.loadParams();
    eventBus.$on('refresh-list', this.getTableData); // 监听刷新事件
  },
  beforeDestroy() {
    eventBus.$off('refresh-list', this.getTableData); // 解绑事件
  },
  data() {
    return {
      pageTitle: "用户余额列表",
      labelWidth: '120px',
      tableDataApi: '/api/balance-list',

      searchForm: {
        user: '',
      },
      period: [],
      currentRow: {},
    }
  },
  methods: {
    loadParams () {
      if('username' in this.$route.query && this.$route.query.username) {
        this.searchForm.username = this.$route.query.username
      }
      if('page' in this.$route.query && this.$route.query.page) {
        this.pagination.page = parseInt(this.$route.query.page, 10)
        this.pagination.currentPage = this.pagination.page
      }
      if('pageSize' in this.$route.query && this.$route.query.pageSize) {
        this.pagination.pageSize = parseInt(this.$route.query.pageSize,10)
      }
      if('total' in this.$route.query && this.$route.query.total) {
          this.pagination.total = parseInt(this.$route.query.total, 10)
      }
      this.handleCurrentChange(this.pagination.page)
    },
    handleReset () {
      this.searchForm = {
        use: '',
      }
      this.getTableData()
    },
    handleSearch () {
      this.getTableData()
    },

    

    formatStatus(status) {
      const map = {
        0: '正常',
        1: '正常',
        2: '欠费待处置',
        3: '欠费已被冻结'
      };
      return map[status] || '未知';
    },
    statusTagType(status) {
      const typeMap = {
        0: 'success',     // 灰色
        1: 'success',  // 绿色
        2: 'warning',  // 黄色/橙色
        3: 'danger'    // 红色
      };
      return typeMap[status];
    },
    formatCost(row, column, cellValue) {
      // 格式化金额为两位小数
      return parseFloat(cellValue).toFixed(2);
    },

    // 编辑充值
    updataedit(row) {
      console.log('选中的用户数据:', row); // 确保这里能打印出 username
      this.$refs.EditUpdate.init({ ...row }, this.appTypeList);
    },

    // 用户同步
    userSynchronous(){ 
      this.$axios.get('/api/sync-user')
      .then(res => {  
        console.log('用户同步结果:', res);
         if(res.code === 200) {
          this.$message.success('用户同步成功');
          this.getTableData();
        } else {
          this.$message.error(res.data.msg);
        }
      }).catch(error => {
        this.$message({
          message: '同步失败',
          type: 'error',
          duration: 1500,
        });
      });
    },

     // 点击跳转充值记录
    rechargeRecord(row) {
      this.$router.push({
        path: '/user-recharge-record', // 请确认路径是否匹配您的路由
        query: {
          username: row.username,
        }
      });
    },
    
  }

}
</script>

<style scoped lang="scss">
.pagebody {
  margin-top: 20px;
  margin-left: 20px;
}
.filter-bar {
  margin-bottom: 10px;
}
.main-table {
  margin-top: 10px;
}

.search-button-line {
  display: flex;
  justify-content: flex-end;
}
.batch-button {
  min-width: 95px;
}
</style>